import React from 'react';
import { getMaskedUserInput } from '../../../AlmeResponse/AlmeResponse';
import { UserCardContainer, UserText } from '../../../AlmeResponse/AlmeResponse.styles';
import { UserAvatar } from '../../../AlmeUtilities/Icons/UserAvatar';
import { UserCardBubble } from '../../../AlmeResponse/ChatBubble';
export function isValidLiveChatUserResponse(response) {
    var _a;
    const maskedUserInput = getMaskedUserInput(response);
    const hasUserInput = !!maskedUserInput;
    return ((_a = response === null || response === void 0 ? void 0 : response.extensionData) === null || _a === void 0 ? void 0 : _a.MessageOrigin) === 'User' && hasUserInput;
}
const AlmeLiveChatUserResponse = (props) => {
    if (!isValidLiveChatUserResponse(props.response)) {
        return null;
    }
    const maskedUserInput = getMaskedUserInput(props.response);
    const responseRevision = (props.responseId || props.response.responseRevision).toString();
    const entryId = props.response.extensionData.entryId || responseRevision;
    return (React.createElement(React.Fragment, null, maskedUserInput &&
        React.createElement(UserCardContainer, { id: `alme-user-card-${responseRevision}` },
            React.createElement(UserCardBubble, { key: `${entryId}-user` },
                React.createElement(UserText, null, maskedUserInput)),
            React.createElement(UserAvatar, { size: 40 }))));
};
export default AlmeLiveChatUserResponse;
